import { Operation } from '../../../__generated__/globalTypes'

import {
  Storefront,
  storefrontString,
} from '../../fragments/__generated__/Storefront'

import updateStorefrontMugshotRawString from '../UpdateStorefrontMugshot.graphql'

const updateStorefrontMugshotString = [
  updateStorefrontMugshotRawString,
  storefrontString,
].join('\n\n')

export type UpdateStorefrontMugshotData = {
  updateStorefrontMugshot: {
    storefront: Storefront
  }
}

export type UpdateStorefrontMugshot = Operation<UpdateStorefrontMugshotData>

export const UpdateStorefrontMugshot = (): UpdateStorefrontMugshot => ({
  query: updateStorefrontMugshotString,
  variables: undefined,
})
